import { Component, OnInit } from '@angular/core';
//import { UserStateService } from '../shared/services/user-state.service';
import { ActivatedRoute } from '@angular/router';
import { Route } from '@angular/router';

// https://blog.angular-university.io/angular-2-router-nested-routes-and-nested-auxiliary-routes-build-a-menu-navigation-system/
// https://loiane.com/2017/08/how-to-add-bootstrap-to-an-angular-cli-project/#1-creating-an-angular-project-with-angular-cli
// https://medium.com/codingthesmartway-com-blog/building-an-angular-5-project-with-bootstrap-4-and-firebase-4504ff7717c1
// https://getbootstrap.com/docs/4.0/examples/starter-template/
// https://www.marathonus.com/about/blog/kickstarting-an-angular-5-project-with-bootstrap-4-sass-and-font-awesome/
// https://ng-bootstrap.github.io/#/getting-started
// https://www.youtube.com/watch?v=zEvzW_sSXk0
// https://www.techiediaries.com/angular-bootstrap/
// ** https://www.bootstrapdash.com/use-bootstrap-4-with-angular/
@Component({
  selector: 'app-nav-bar',
  templateUrl: './app-nav-bar.component.html',
  styleUrls: ['./app-nav-bar.component.scss']
})
export class AppNavBarComponent implements OnInit {

  constructor(
    /*protected _UserStateService: UserStateService*/ ) { }
    isCollapsed= true
  ngOnInit() {
    //console.warn(this._UserStateService.loggedIn);
  }

}
